"use client";
import { ChevronUp } from "@/components/newIcons/ChevronUp";
import clsx from "clsx";
import { useState } from "react";

type Props = {
  children: React.ReactNode;
};
export const SpeakerClient = ({ children }: Props) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <div
        className={clsx("", {
          "max-lg:hidden": !visible,
        })}
      >
        {children}
      </div>
      <div
        className={clsx("flex items-center cursor-pointer lg:hidden", {
          "mt-5": visible,
          "mt-[10px]": !visible,
        })}
        onClick={() => setVisible(!visible)}
      >
        <p className="text-xs leading-6 underline mr-[5px]">
          {visible ? "Ferme sa présentation" : "Voir sa présentation"}
        </p>
        <ChevronUp
          className={clsx("w-4 h-4 transition-all text-primary", {
            "rotate-180": !visible,
          })}
        />
      </div>
    </>
  );
};
